__turbopack_context__.v({
  "className": "rubik_6f8d6814-module__siSTlW__className",
});
